import { z } from "zod/v3";
import { ZodOutputFor, createSchema } from "../zod-utils";
import { PlainMessage } from "@bufbuild/protobuf";
import { HipTask, hipTaskSchema } from "../models/hipTask";
import { HipTasksResponse } from "@opstel/gen/knop/ui/v1/api/hip_pb";
import { ResponseStatus, responseStatusSchema } from "./util/responseStatus";

export interface HipTasks {
  status: ResponseStatus;
  hipTasks: HipTask[];
}

export const hipTasksSchema = createSchema<HipTasks, PlainMessage<HipTasksResponse>>({
  hipTasks: z.array(hipTaskSchema),
  status: responseStatusSchema,
  message: z.string(),
}) satisfies ZodOutputFor<HipTasks>;

export function parseHipTasksData(proto: PlainMessage<HipTasksResponse>): HipTasks {
  return hipTasksSchema.parse(proto);
}
